import Chemistry from './Chemistry';

export default Chemistry;
